module.exports = __webpack_public_path__ + "static/axa-3352d8c0dd78d2056529d8980f184bd5.jpeg";